module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABL0lEQVQ4T82SPUsDQRCGn7mDvWsUDdqnFZtYWPgLxEJBsbTfEOF+TEDIphZsxEIL8R+ITays0weiaHVLciMnuXDKmURBcJv9GOaZd94dYbKcc2vAE7BevFXsgzRNN5MkGRQxKQ7dbrehqr0ZyR+h8Xi802q17v8OoKp3InJkjMmKKt77QFWvRGR3EQVDVb0MgmAKyLIsEJFjoFYJaLfbURzHGyUPPDAFAAFgCg9Go1EvSZI0v4tzLjduRUQOJ4Aba+3BVzOdc9fAfq4gDMML4MVau5UDFOiXAG+qeisiUwWqmrewByyVAHVrrVQBZv7ktwBge9FBiqLoAfikIDekYYzpzxsk730deASicgvz8irj/wcwBFZ/0cOztbYmnU7nRETOgOUfQF5V9bTZbJ6/A/N4vxEplVsEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/sider/sider3-1.png
// module id = 971
// module chunks = 2